import { COOKIEBOT_DOMAIN_ID } from '@/lib/analytics';
import { getNavigation } from '@/lib/sanity/queries';

import Layout from '@/components/layout';
import { CookiebotDeclaration } from '@/components/cookiebot-declaration';

export function CookiesPage() {
  return (
    <Layout loading={false} isPreview={false}>
      <main suppressHydrationWarning>
        <CookiebotDeclaration domainId={COOKIEBOT_DOMAIN_ID ?? ''} />
      </main>
    </Layout>
  );
}

export async function getStaticProps() {
  const navigation = await getNavigation();

  return {
    props: {
      navigation,
    },
    revalidate: 60 * 60,
  };
}

export default CookiesPage;
